const findImageHref = require("./findImageHref");
const findFileFieldName = require("./findFileFieldName");

module.exports = function extractFileData(media_rel, file_field_name = null, sitemap) {
	file_field_name = file_field_name || findFileFieldName(media_rel);
	if (file_field_name) {
		const file =
			media_rel && media_rel.relationships && media_rel.relationships[file_field_name]
				? media_rel.relationships[file_field_name].data
				: null;
		let caption =
			media_rel.attributes && media_rel.attributes.field_caption
				? media_rel.attributes.field_caption
				: null;
		if (caption) {
			let rich_caption = caption.split("|");
			if (rich_caption.length === 2) {
				caption = `<em>${rich_caption[0]}</em> ${rich_caption[1]}`;
			}
		}

		if (file && file.meta) {
			const file_url = file?.attributes?.image_style_uri?.crop_thumbnail
				? file?.attributes?.image_style_uri?.crop_thumbnail
				: `${process.env.CLF_BACKEND_URL}${file?.attributes?.uri?.url || ""}`;

			const src = file_url;
			const format =
				file.attributes && file.attributes.uri
					? file.attributes.uri.url.split(".").pop()
					: null;
			const href =
				sitemap && media_rel && media_rel.attributes
					? findImageHref(media_rel.attributes, media_rel, file, sitemap)
					: null;
			const f = { id: media_rel.id, ...file.meta, src, format, href, caption };
			return f;
		} else {
			return null;
		}
	}
	return null;
};
